import { mergeFragments } from "../../mergeFragments";
import base from "./base";
import actions from "./actions";
import errorBoundary from "./errorBoundary";
import lib from "./lib";
import validation from "./validation";
import gatewayErrors from "./gatewayErrors";
import loadFailure from "./loadFailure";
import entitlements from "./entitlements";
import pathwayErrors from "./pathwayErrors";
import platformOffers from "./platformOffers";
import counts from "./counts";
import siteContentErrors from "./siteContentErrors";

export default mergeFragments([base, actions, errorBoundary, lib, validation, gatewayErrors, loadFailure, entitlements, pathwayErrors, platformOffers, counts, siteContentErrors]);
